import React from "react";
import RichText from "components/rich-text";
import Image from "components/image";
import { useState } from "react";
import Link from "helpers/link";
import { CHECKOUT_DOMAIN } from "utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { useGlobalContext } from "context/global";
import { addLittledataAttributes } from "actions/cart";
import clsx from "clsx/lite";
import { toggleCheckoutLoading } from "slices/cart";

const GiftCard = ({ product, giftCardPage, currentVariant }) => {
	const [activeVariant, setActiveVariant] = useState(0);
	const variant = currentVariant ? currentVariant : product?.variants[activeVariant];
	const dispatch = useDispatch();
	const { langCode, translation } = useGlobalContext();
	const { shopifyClient } = useSelector(state => state.global);
	const isAvailable = ["available", "one-time"].includes(variant?.stock) && variant?.price > 0;

	const VariantOptions = ({ variants, activeVariant, setActiveVariant }) => (
		variants?.map((v, i) => (
			giftCardPage ? (
				<Link
					state={{ preserveScroll: true }}
					className="account-section-pills font-bold md:!py-2.5 !py-1 !px-4 md:!px-8 w-full"
					activeClassName="!border-[#000]"
					to={`/products/${product?.handle}/${v?.handle}`}
					key={i}
				>
					{v.title}
				</Link>
			) : (
				<button
					key={i}
					className={
						clsx(`account-section-pills font-bold md:!py-2.5 !py-1 !px-4 md:!px-8`, i === activeVariant && "!border-black")
					}
					onClick={() => setActiveVariant(i)}
				>
					{v.title}
				</button>
			)
		))
	);

	const addToCart = async () => {
		try {
			const merchandiseId = variant.id;
			const lines = [{ merchandiseId, quantity: 1 }];
			const cart = await shopifyClient.cart.create({ lines });
			const url = cart.checkoutUrl + "&locale=" + langCode;
			const checkoutUrl = new URL(url);

			await dispatch(addLittledataAttributes(cart));

			if (checkoutUrl) {
				window.location.href = url.replace(checkoutUrl.hostname, CHECKOUT_DOMAIN);
			}
		} catch (error) {
			console.error("Error creating or adding items to cart:", error);
			dispatch(toggleCheckoutLoading());
		}
	};

	return (
		<div className="flex flex-col xl:flex-row justify-center w-full md:w-3/4 items-center m-auto gap-10 md:mt-10">
			<div className="w-11/12 md:w-3/4">
				<Image image={variant?.image} alt={variant?.image?.alt} />
			</div>
			<div className="w-11/12 xl:w-2/5">
				<RichText value={product?.description?.data} />
				<div className="flex my-5 justify-between">
					<VariantOptions variants={product?.variants} activeVariant={activeVariant} setActiveVariant={setActiveVariant} />
				</div>
				<div className="my-5">
					<button disabled={!isAvailable} className="w-full btn-primary" onClick={addToCart}>
						{translation.product?.addToCart}
					</button>
				</div>

				<span className="text-secondary text-sm">{product?.info}</span>
			</div>
		</div>
	);
};

export default GiftCard;
